import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskLiveChatMyChatsRoute: InvariantJiraRoute = {
	name: 'servicedesk-live-chat-my-chats',
	path: '/jira/servicedesk/projects/:projectKey/live-chat/my-chats',
	exact: true,
};
